import { Api } from "@/api";
import { UserLoginType, UserType } from "@/DTO";

export const GetUserById = (user: UserLoginType, id: string) => {
  return new Promise<{
    data: UserType
  }>((resolve, reject) => {
    const api = new Api({
      method: "get",
      path: `user/${id}`,
      header: {
        Authorization: "Bearer " + user.accessToken,
        "Content-Type": "application/json"
      }
    });
    return api
      .call()
      .then((data: any) => {
        return resolve({
          data: ConvertToUserType(data.data)
        });
      })
      .catch((err: any) => {
        return reject(err);
      });
  });
};

export const ConvertToUserType = (item: any): UserType => {
  return {
    id: item.id,
    first_name: item?.first_name,
    last_name: item?.last_name,
    phone: item?.phone,
    status: item?.status,
    address: item?.address,
    created_at: item?.created_at
  };
};

